module.exports = __webpack_public_path__ + "static/media/logo_light_blue.fd535f8d.png";